package com.bikompanion.data.gbfs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsStationInformationDto(
    @SerialName("station_id") val stationId: String,
    @Serializable(with = GbfsTextSerializer::class) val name: String = "",
    val lat: Double,
    val lon: Double,
    val capacity: Int? = null,
)
